import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mobileOpen: false,
  isClosing: false,
  drawerWidth: 260
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    handleDrawerClose: (state) => {
      state.isClosing = true
      state.mobileOpen = false
    },
    handleDrawerTransitionEnd: (state) => {
      state.isClosing = false
    },
    handleDrawerToggle: (state) =>{
      if(!state.isClosing){
        state.mobileOpen = !state.mobileOpen
      }
    }
  }
})

export default dashboardSlice.reducer
export const dashboardActions= dashboardSlice.actions 